// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  baseHref: '/v2/',
  connextPartnerId: 5,
  mynevaPartnerId: 4,
  medifoxPartnerId: 6,
  apiUrl: 'https://shopapp.dev.cloudliesel.tech/api/api',
  appName: 'new-shop-fe',
  X_BL_ORIGIN: 'APP_SHOP',
  firebaseConfig: {
    apiKey: 'AIzaSyD-Re9IEviXSQFsvA5MEEEk8hUzJ_U-tds',
    authDomain: 'fir-login-dev-8ff5e.firebaseapp.com',
    projectId: 'fir-login-dev-8ff5e',
    storageBucket: 'fir-login-dev-8ff5e.firebasestorage.app',
    messagingSenderId: '169213448330',
    appId: '1:169213448330:web:df97ebd87af7220ec5dd73',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
